import { Injectable } from "@angular/core";
import { DISABLE_APPSFLYER_COOKIE_KEY } from "app/common";
import { CookieService } from "ngx-cookie-service";
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: "root" })
export class AppsFlyerConsentService {
  private analyticsConsent$ = new BehaviorSubject<boolean>(
    this.cookieService.get(DISABLE_APPSFLYER_COOKIE_KEY) === "false"
  );
  analyticsConsentChanges$ = this.analyticsConsent$.asObservable();

  constructor(private cookieService: CookieService) {}

  setConsent(allow: boolean) {
    this.cookieService.set(DISABLE_APPSFLYER_COOKIE_KEY, (!allow).toString(), { path: "/", sameSite: "Lax" });
    this.analyticsConsent$.next(allow);
  }
}
